import { useCartContext } from './index';

/**
 * Header da tabela do carrinho — labels uppercase, mesmo grid das rows.
 * Sticky no topo durante scroll do items area.
 */
function HeaderCell({ T, align = 'left', last = false, children }) {
    return (
        <div
            style={{
                padding: '0 10px',
                height: 36,
                display: 'flex',
                alignItems: 'center',
                justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
                borderRight: last ? 'none' : `1px solid ${T.line}`,
                fontSize: 11,
                fontWeight: 600,
                color: T.muted,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
                fontFamily: T.sans,
            }}
        >
            {children}
        </div>
    );
}

export function CartHeader() {
    const { T, CART_GRID_COLS } = useCartContext();
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: CART_GRID_COLS,
                background: T.bgMid,
                borderBottom: `1px solid ${T.lineMid}`,
                position: 'sticky',
                top: 0,
                zIndex: 2,
            }}
        >
            <HeaderCell T={T}>Produto</HeaderCell>
            <HeaderCell T={T} align="right">
                Estoque
            </HeaderCell>
            <HeaderCell T={T} align="right">
                Custo un.
            </HeaderCell>
            <HeaderCell T={T} align="center">
                Qtd
            </HeaderCell>
            <HeaderCell T={T} align="right">
                Subtotal
            </HeaderCell>
            <HeaderCell T={T} align="center" last />
        </div>
    );
}
